import { render } from "./PremiumLaborBreakdown.vue?vue&type=template&id=497acd1d&scoped=true&ts=true"
import script from "./PremiumLaborBreakdown.vue?vue&type=script&lang=ts"
export * from "./PremiumLaborBreakdown.vue?vue&type=script&lang=ts"

import "./PremiumLaborBreakdown.vue?vue&type=style&index=0&id=497acd1d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497acd1d"]])

export default __exports__